import { motion } from "framer-motion";

const CHAPTERS = [
  { num: "01", title: "La Esencia", text: "Cada frasco guarda una historia. Seleccionamos las materias primas más nobles del mundo para componer aromas que se convierten en parte de tus mejores recuerdos." },
  { num: "02", title: "La Artesanía", text: "Perfumería de autor, en pequeños lotes. Sin prisas, sin compromisos. Solo la búsqueda incansable del equilibrio perfecto entre nota y emoción." },
  { num: "03", title: "La Experiencia", text: "De nuestra maison a tu puerta. Entregamos personalmente cada pedido y pagas al recibirlo: confianza pura, como debe ser el lujo." },
];

export const Manifesto = () => {
  return (
    <section id="manifiesto" className="relative py-32 px-6 bg-noir-soft/50 border-y border-white/5" data-testid="manifesto-section">
      <div className="max-w-5xl mx-auto">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="block text-center font-script-lux text-gold text-3xl mb-24"
        >
          Nuestro manifiesto
        </motion.span>
        <div className="space-y-28">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className={`flex flex-col md:flex-row items-start gap-8 md:gap-16 ${i % 2 === 1 ? "md:flex-row-reverse md:text-right" : ""}`}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="font-serif-lux text-7xl md:text-8xl text-gold/25 leading-none shrink-0">{c.num}</span>
              <div>
                <h3 className="font-serif-lux text-3xl md:text-4xl tracking-[0.2em] uppercase text-white">{c.title}</h3>
                <p className="text-neutral-400 font-light leading-relaxed mt-5 max-w-lg">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
